<template>
  <div>
    <Main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      @openEditForm="openEditForm"
      :disabled="disabled"
      @change="(rows) => $emit('change', rows)"
    >
      <template #header>
        <div class="side-frame-success group-title">
          {{ $l('form_group_fabric_color') || '面料颜色明细' }}
          <el-divider direction="vertical" v-if="!disabled" />
          <b-button
            v-if="!disabled"
            size="sm"
            variant="outline-success"
            @click="openEditForm({ type: 'add' })"
          >
            <b-icon-plus />
            {{ $l('form_table_btn_label_add') || '新增颜色' }}
          </b-button>
        </div>
      </template>
    </Main>

    <EditForm
      :visible.sync="editFormOpts.visible"
      :type="editFormOpts.type"
      :row="editFormOpts.row"
      :tableData="editFormOpts.tableData"
      @success="editSuccess"
    />
  </div>
</template>
<script>
import Main from './main.vue'
import EditForm from './components/edit-form'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  components: { Main, EditForm },
  props: {
    fabricRequestCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    fabricRequest: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      loading: false,
      tableData: [],
      editFormOpts: { visible: false, type: '', row: {}, tableData: [] },
    }
  },
  computed: {
    fabricRequestModel() {
      const { fabricUnit, fabricWeight, fabricWeightUnit, wid, widUnit } =
        this.fabricRequest || {}
      return { fabricUnit, fabricWeight, fabricWeightUnit, wid, widUnit }
    },
  },
  watch: {
    fabricRequestModel: {
      handler() {
        this.resloadAllCalcRequestMetre()
      },
      deep: true,
    },
  },
  // mounted() {
  //   this.getData()
  // },
  methods: {
    async getData() {
      if (!this.fabricRequestCode) return
      this.loading = true
      const res = await this.$api
        .fabricRequestColorListApi({
          fabricRequestCode: this.fabricRequestCode,
        })
        .catch(() => null)
      this.loading = false
      const data = res?.body?.data || []

      let itemIndex = 1
      this.tableData = data.map((row) => ({ ...row, itemIndex: itemIndex++ }))

      this.$emit('change', this.tableData)
    },
    openEditForm({ type, row = {} } = {}) {
      this.editFormOpts = {
        visible: true,
        type,
        row,
        tableData: this.getTableData(),
      }
    },
    async editSuccess(data) {
      const { itemIndex } = data
      // 计算需求数量
      const calc = await this.calcRequestMetre(data.requestQuantity)
      const requestMetre = calc?.total

      const $main = this.$refs.main
      const tableData = $main.getTableData()

      if (!itemIndex) {
        let maxItemIndex = 1
        if (tableData?.length) {
          maxItemIndex = tableData.reduce((prev, current) =>
            prev.itemIndex > current.itemIndex
              ? prev.itemIndex
              : current.itemIndex
          )
        }

        await $main.insertAt({
          ...data,
          requestMetre,
          itemIndex: maxItemIndex + 1,
        })

        this.$emit('change', $main.getTableData())
        return
      }

      const findIndex = tableData.findIndex(
        (row) => row.itemIndex === itemIndex
      )
      tableData[findIndex] = { ...tableData[findIndex], ...data, requestMetre }
      $main.reloadData(tableData)

      this.$emit('change', tableData)
    },
    getTableData() {
      return this.$refs.main.getTableData()
    },
    async resloadAllCalcRequestMetre() {
      const tableData = this.getTableData()
      if (tableData?.length) {
        const calc = await this.calcRequestMetre(
          ...tableData.map((row) => row.requestQuantity)
        )

        const results = calc?.results || []

        for (const rowIndex in tableData) {
          const row = tableData[rowIndex]
          row.requestMetre = results[rowIndex] || 0
        }
      }

      this.$emit('change', tableData)
      this.$refs.main.reloadData(tableData)
    },
    async calcRequestMetre(...requestQuantitys) {
      if (!requestQuantitys?.length) return

      this.loadingOpen()
      const res = await this.$api
        .fabricRequestCalcRequestMetreApi({
          ...this.fabricRequestModel,
          requestQuantitys: !requestQuantitys?.length ? [] : requestQuantitys,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('tips_calcRequestMetre_no') || '计算失败！')
        return
      }

      return res.body
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
  margin: 15px 0;
}
.side-frame-success {
  padding: 1px 10px;
  border-left: 3px solid $color-success;
  margin: 15px 0;
}
.group-title {
  font-size: 14px;
  color: #606266;
}
</style>
